
















































































































// Vue
import Vue, { PropType } from "vue";
import { mapActions, mapGetters } from "vuex";
// Vuelidate
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// Models
import { UpdateUser, UserModel, UserRole } from "@/core/api/apiClient";
// Services
import AdminService from "@/views/admin/Admin.service";
// Components
import ConfirmationDialog from "@/core/components/content/_dialogs/ConfirmationDialog.vue";

export default Vue.extend({
  name: "CreateUserDialog",
  components: { ConfirmationDialog },
  mixins: [validationMixin],
  props: {
    user: Object as PropType<UserModel>
  },

  data() {
    return {
      dialog: false,
      isValid: false,
      isLoading: false,

      firstName: null as string | undefined | null,
      lastName: null as string | undefined | null,
      userType: null as UserRole | undefined | null,
      email: null as string | undefined | null,

      userTypes: [UserRole.Dispatcher, UserRole.Driver, UserRole.Administrator]
    };
  },

  validations: {
    firstName: { required },
    lastName: { required },
    userType: { required }
  },

  methods: {
    ...mapActions("appMessages", {
      ADD_ERROR_MESSAGE: "ADD_ERROR_MESSAGE",
      ADD_SUCCESS_MESSAGE: "ADD_SUCCESS_MESSAGE"
    }),

    initialize(): void {
      if (this.user) {
        this.firstName = this.user.firstName ?? null;
        this.lastName = this.user.lastName ?? null;
        this.userType = this.user.role ?? null;
        this.email = this.user.email ?? null;
      }
    },

    /**
     * Submits the Updated User to the server and updates the list.
     * @author Nick Brahimir
     */
    submit(): void {
      this.isLoading = true;

      const updatedUser = new UpdateUser({
        clientId: this.user.clientId,
        userId: this.user.userId,
        role: this.userType!,
        firstName: this.firstName ?? undefined,
        lastName: this.lastName ?? undefined,
        email: this.email ?? undefined,
        status: this.user.status
      });

      AdminService.updateUser(updatedUser)
        .then(() => {
          this.isLoading = false;
          if (updatedUser.role === UserRole.Driver) this.$store.dispatch("SET_UPDATE_DASHBOARD", true);
          this.ADD_SUCCESS_MESSAGE(`User successfully updated.`);

          this.$emit("refresh-users");
          this.close();
        })
        .catch((error) => {
          this.isLoading = false;
          this.ADD_ERROR_MESSAGE(`User update failed. Please try again.`);
          console.error(error);
        });
    },

    deleteUser(user: UserModel): void {
      this.isLoading = true;

      AdminService.deleteUser(user.clientId!, user.userId)
        .then(() => {
          this.isLoading = false;
          if (user.role === UserRole.Driver) this.$store.dispatch("SET_UPDATE_DASHBOARD", true);

          this.$emit("refresh-users");
          this.close();
          this.ADD_SUCCESS_MESSAGE(`User successfully deleted.`);
        })
        .catch((error) => {
          this.isLoading = false;
          this.ADD_ERROR_MESSAGE(`Failed to delete user. Please try again.`);
          console.error(error);
        });
    },

    /**
     * Clears the login form.
     * @author Nick Brahimir
     */
    close(): void {
      this.firstName = null;
      this.lastName = null;
      this.userType = null;
      this.email = null;

      this.$v.$reset();
      this.dialog = false;
    }
  },

  computed: {
    ...mapGetters({ currentUser: "currentUser" }),

    /**
     * Parses any firstName errors.
     * @author Nick Brahimir
     */
    firstNameErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.$dirty) return errors;
      !this.$v.firstName.required && errors.push("First name is required");
      return errors;
    },

    /**
     * Parses any lastName errors.
     * @author Nick Brahimir
     */
    lastNameErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.$dirty) return errors;
      !this.$v.lastName.required && errors.push("Last name is required");
      return errors;
    },

    /**
     * Parses any userTyoe errors.
     * @author Nick Brahimir
     */
    userTypeErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.$dirty) return errors;
      !this.$v.userType.required && errors.push("User type is required");
      return errors;
    }
  }
});
